<div class="aupris_main">
<h5>Telefonnumern machen die Lieferterminabsprache leichter. Bitte tragen Sie daher alle verfügbaren Telefonnummern ein.</h5>
<button class="au-btn btn-default futuresbutton"  (click)="onclick('Ignorieren')" [ngStyle]="{background: colors.Grundfarbe,color: colors.Schriftfarbe_Buttons}">Ignorieren</button>
<button class="au-btn btn-default futuresbutton" [ngStyle]="{background: colors.Grundfarbe,color: colors.Schriftfarbe_Buttons}"  style="float:right" 
 (click)="onclick('Korrigieren')">Korrigieren</button>
</div>
